import request from '@/utils/http';
const otpBaseUrl = 'api-antms/lsp';
// 司机分页查询
export const driverGetList = (data) => {
    return request({
        url: `${otpBaseUrl}/driver/info/page`,
        method: 'POST',
        data
    });
};

// 新增司机配置
export const addDriver = (data) => {
    return request({
        url: `${otpBaseUrl}/driver/info/save`,
        method: 'POST',
        data
    });
};


// 删除司机配置
export const deleteDriver = (data) => {
    return request({
        url: `${otpBaseUrl}/driver/info/delete`,
        method: 'POST',
        headers: {
            'Content-Type': 'application/json;charset=utf-8'
        },
        data
    });
};

